import { font } from '@approvalmax/ui';
import styled from 'styled-components';

export const ErrorText = styled.div`
    ${font(14, '#a3341a', 'bold')}
`;
